import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { AcceptInvitePage } from "@/presentation/pages/AcceptInvitePage";

const searchSchema = z.object({
  token: z.string().min(1),
});

interface AcceptInviteSearch {
  token: string;
}

export const Route = createFileRoute("/accept-invite")({
  validateSearch: (search: Record<string, unknown>): AcceptInviteSearch => {
    const parsed = searchSchema.safeParse(search);
    return parsed.success ? parsed.data : { token: "" };
  },
  component: function AcceptInviteRouteComponent() {
    const { token } = Route.useSearch();
    return <AcceptInvitePage token={token} />;
  },
});
